import { render, staticRenderFns } from "./LayoutBreadcrumb.vue?vue&type=template&id=2b16207a&scoped=true"
import script from "./LayoutBreadcrumb.vue?vue&type=script&lang=js"
export * from "./LayoutBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./LayoutBreadcrumb.vue?vue&type=style&index=0&id=2b16207a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16207a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b16207a')) {
      api.createRecord('2b16207a', component.options)
    } else {
      api.reload('2b16207a', component.options)
    }
    module.hot.accept("./LayoutBreadcrumb.vue?vue&type=template&id=2b16207a&scoped=true", function () {
      api.rerender('2b16207a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/LayoutBreadcrumb.vue"
export default component.exports